import { useCallback, useEffect, useRef, useState } from 'react';

export const useFocusLost = <El extends HTMLElement>(onClick: () => void) => {
    const [ref, setRef] = useState<El | null>(null);
    const clickHandlerRef = useRef(onClick);
    clickHandlerRef.current = onClick;

    const handler = useCallback<EventListener>(
        (event) => {
            if (!!ref && event.target instanceof HTMLElement && !ref.contains(event.target)) {
                clickHandlerRef?.current?.();
            }
        },
        [ref, clickHandlerRef],
    );

    useEffect(() => {
        if (ref && handler) {
            document.body.addEventListener('click', handler);
            document.body.addEventListener('focusin', handler);
        } else {
            document.body.removeEventListener('click', handler);
            document.body.removeEventListener('focusin', handler);
        }

        return () => {
            document.body.removeEventListener('click', handler);
            document.body.removeEventListener('focusin', handler);
        };
    }, [ref, handler]);

    return [setRef];
};
